import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { id as idLocale } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { fmtDate } from "@/lib/constants";

// ISO "YYYY-MM-DD" <-> Date lokal tanpa geser zona waktu.
const toDate = (iso) => {
  if (!iso) return undefined;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};
const toIso = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;

/**
 * Pemilih tanggal eksplisit — pengganti <input type="date"> native yang di
 * Safari menampilkan tanggal hari ini walau nilainya kosong. Nilai kosong
 * SELALU tampil sebagai placeholder; tidak ada default tanggal.
 */
export const DueDatePickerField = ({ value, onChange, disabled, minDate, testId, placeholder = "Pilih tanggal" }) => {
  const [open, setOpen] = useState(false);
  const selected = toDate(value);
  const min = toDate(minDate);
  return (
    <div className="inline-flex items-center gap-1">
      <Popover open={open && !disabled} onOpenChange={(o) => setOpen(o && !disabled)}>
        <PopoverTrigger asChild>
          <button type="button" disabled={disabled} data-testid={testId}
            className={`inline-flex items-center gap-1.5 border py-1 px-2 text-xs w-36 text-left ${disabled ? "bg-slate-100 border-slate-200 text-slate-400 cursor-not-allowed" : "bg-white border-slate-300 hover:border-emerald-500"}`}>
            <CalendarDays size={12} className="shrink-0" />
            {value ? <span className="font-semibold text-slate-800" data-testid={`${testId}-value`}>{fmtDate(value)}</span>
              : <span className="text-slate-400 italic" data-testid={`${testId}-placeholder`}>{disabled ? "—" : placeholder}</span>}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 z-[60]" align="start">
          <Calendar mode="single" locale={idLocale} selected={selected} defaultMonth={selected || min}
            disabled={min ? { before: min } : undefined}
            onSelect={(dt) => { if (dt) { onChange(toIso(dt)); setOpen(false); } }} />
        </PopoverContent>
      </Popover>
      {value && !disabled && (
        <button type="button" onClick={() => onChange("")} className="text-slate-400 hover:text-rose-600" title="Kosongkan tanggal" data-testid={`${testId}-clear`}>
          <X size={12} />
        </button>
      )}
    </div>
  );
};
